// @flow

import styled from 'styled-components';
import { Button, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

type ChatPanelHeaderProps = {
  isMinimized: boolean,
  onToggle: () => void,
  title?: string,
};

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  background: var(--panel-header-bg);
  border-bottom: 1px solid var(--panel-border);
`;

const Title = styled.span`
  font-family: var(--fonts-heading);
  font-size: 14px;
  color: var(--widget-heading-text);
`;

const ChatPanelHeader = ({ 
  isMinimized, 
  onToggle, 
  title = 'Ask me about this report' 
}: ChatPanelHeaderProps): React$Node => (
  <Header>
    <Title>
      <Icon icon={IconNames.CHAT} size={14} style={{ marginRight: '0.5rem' }} />
      {title}
    </Title>
    <Button
      minimal
      small
      icon={isMinimized ? IconNames.MAXIMIZE : IconNames.MINIMIZE}
      onClick={onToggle}
      title={isMinimized ? 'Expand chat' : 'Minimize chat'}
    />
  </Header>
);

export default ChatPanelHeader;
